import React, { FC } from 'react';

const Flammable: FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 170 170"
    fill="none"
    {...props}
  >
    <g clipPath="url(#Flammable_1)">
      <path
        fill="#EB1F26"
        d="m160.98 85.135-75.951 75.952-75.95-75.952 75.949-75.95 75.952 75.95Z"
      />
      <path
        stroke="#EB1F26"
        strokeWidth={0.9}
        d="m160.98 85.135-75.951 75.952-75.95-75.952 75.949-75.95 75.952 75.95Z"
      />
      <path
        fill="#fff"
        d="m148.823 85.14-63.794 63.796-63.795-63.795 63.795-63.795 63.794 63.795Z"
      />
      <path
        fill="#231F20"
        fillRule="evenodd"
        d="M109.615 118.378H63.681v-4.86h45.934v4.86Z"
        clipRule="evenodd"
      />
      <mask
        id="Flammable_2"
        width={156}
        height={156}
        x={7}
        y={7}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M7.278 162.886H162.78V7.384H7.279v155.502Z" />
      </mask>
      <g mask="url(#Flammable_2)">
        <path
          fill="#231F20"
          fillRule="evenodd"
          d="M85.966 108.719s-.721-.132-1.705-.262c-.984-.133-3.279-.133-6.887-2.428-3.608-2.296-4.526-6.1-5.182-7.281-.655-1.181-1.443-3.213-1.443-3.213s2.492 2.032 4.396 2.557c1.9.525 4.919.525 4.919.525s-3.15-3.936-3.935-5.904c-.79-1.968-.984-2.493-.59-3.148.392-.657.654-1.246.654-1.773v-2.557s1.444 4.265 3.084 5.314c1.64 1.05 3.606 1.77 3.87 2.099l.262.328s-.198-1.312-.394-2.559c-.197-1.246-.46-4.068 0-5.248.46-1.18 1.903-4.682 2.23-6.54.33-1.856.065-6.054.065-6.054s1.837 1.837 2.69 2.821c.853.984 2.427 3.344 2.689 4.001.264.656 1.05 4 1.183 4.984.13.986.13 8.595.13 8.595s1.05-1.772 1.97-2.295c.916-.526 3.605-2.166 4-2.689.393-.527 1.31-2.823 1.31-2.823s.33 4.002.067 5.312c-.263 1.314-1.312 3.807-1.772 4.595-.457.785-3.081 3.672-3.081 3.672s2.022.019 3.672-.261c2.689-.46 4.919-2.298 4.919-2.298s-1.968 4.396-3.016 5.772c-1.052 1.378-3.74 3.739-4.92 4.659-1.18.917-3.215 2.164-3.215 2.164s2.9.625 7.609-.787c3.28-.984 7.609-4.066 8.986-6.362 1.379-2.296 4.266-4.462 4.855-19.68-.723 3.937-1.116 3.74-1.903 4.329-.786.59-2.689 1.313-4.001 1.705-1.312.394-1.903.526-1.903.526s3.279-4.395 3.936-6.428c.656-2.035 1.444-4.854 1.247-6.363-.197-1.51-2.033-7.873-2.033-7.873s-1.443 3.281-2.1 4.198c-.656.919-2.166 2.363-2.82 2.756-.656.392-2.82 1.508-2.82 1.508s.261-1.048.72-2.032c.458-.984.852-1.378 1.049-2.165.199-.787 0-9.052-.655-11.348-.656-2.297-2.754-5.51-2.754-5.51s-.263 5.247-.656 6.56c-.394 1.311-.976 4.154-1.706 5.18-1.444 2.035-3.214 1.903-3.673 2.1 0 0 .656-1.18.656-3.607 0-2.427-1.05-5.642-2.099-8.726-1.05-3.082-4.527-8.33-5.051-9.904-.526-1.574-1.048-5.378-1.246-6.166-.197-.787-.33-.983-.526-.458-.197.524-1.64 4.919-1.704 6.166-.067 1.245-.067 7.345-.263 9.838-.196 2.494-.656 5.575-1.05 6.952-.393 1.379-2.165 4.395-2.165 4.395s-1.901-2.885-2.099-4.328c-.195-1.443-.328-5.116-1.835-6.757-1.51-1.639-4.003-2.099-4.003-2.099s.59 2.428.59 3.41c0 .985-1.442 6.495-1.245 9.71.196 3.213 1.245 6.23 1.245 6.23s-2.165-1.31-2.689-1.835c-.524-.526-1.901-3.018-2.952-4.331-1.05-1.31-2.82-2.885-2.82-2.885s.459 3.805.59 5.642c.132 1.836.14 5.736.394 7.806.394 3.214 3.412 8.33 3.412 8.33s-2.952 0-4.79-.721c-1.837-.723-3.083-2.952-4-4.199-.92-1.246-2.427-2.296-2.427-2.296s.326 2.755.656 4.199c.328 1.443 2.688 9.052 3.41 11.939.722 2.885 2.494 5.772 4.067 7.149 1.575 1.379 6.232 4.395 10.955 5.511 4.724 1.114 9.641.656 9.641.656Z"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Flammable_1">
        <path fill="#fff" d="M0 0h170v170H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default Flammable;
